const initialState = {
    generalOptions: {}
};

function generalOptions(state = initialState) {
    return state;
}

export default generalOptions;
